import { createSlice } from "@reduxjs/toolkit";

import { IMarkStore } from "../types";

const initialState: IMarkStore = {
  marks: [],
};

export const markSlice = createSlice({
  name: "mark",
  initialState,
  reducers: {
    setMarks: (state, { payload }) => {
      state.marks = payload;
    },
  },
});

export const { setMarks } = markSlice.actions;
